var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("\n    How to resolve this?\n    "),(_vm.showLink)?_c('a',{staticClass:"link",attrs:{"href":"https://headstart.infocusp.com/#/faq","target":"_blank"}},[_vm._v("🔗")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }